<template>
  <div class="an-table-wrap">
    <table class="an-table">
      <thead>
      <tr>
        <th>{{ nameTitle }}</th>
        <th v-for="col in columns" :key="col.key" class="an-num an-sortable"
            :title="col.hint" @click="sortBy(col.key)">
          {{ col.title }}<span v-if="sortKey === col.key"> {{ sortAsc ? '↑' : '↓' }}</span>
        </th>
        <th v-if="rated">Оценка</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="row in sortedRows" :key="row.key">
        <td>
          {{ row.label }}
          <span v-if="row.sub && row.sub !== row.label" class="an-cell-sub">{{ row.sub }}</span>
        </td>
        <td class="an-num">
          {{ formatCount(row.views) }}
          <span class="an-cell-sub">{{ formatPercent(row.share) }}</span>
        </td>
        <td class="an-num">{{ formatPercent(row.bounceRate) }}</td>
        <td v-for="metric in metrics" :key="metric" class="an-num">
          {{ formatMetric(metric, p75(row, metric)) }}
          <RumShareBar v-if="row.metrics && row.metrics[metric]" v-bind="shares(row.metrics[metric])"/>
          <span v-if="change(row, metric)" class="an-cell-sub an-change"
                :class="'an-change--' + change(row, metric).direction">
            {{ change(row, metric).text }}
          </span>
        </td>
        <td v-if="rated">
          <span v-if="row.verdict" class="tf-badge" :class="ratingBadge[row.verdict]">
            {{ ratingText[row.verdict] }}
          </span>
          <span v-else class="an-cell-sub" title="Оценка появляется от 30 замеров">мало данных</span>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import {
  RUM_METRICS,
  METRIC_TEXT,
  RATING_TEXT,
  RATING_BADGE,
  formatMetric,
  formatPercent,
  formatCount,
  formatChange,
} from "@/common/rumFormat";
import RumShareBar from "./RumShareBar.vue";

/**
 * Таблица «строка — четыре метрики». Общая для страниц и аудитории:
 * у страниц есть сравнение с прошлым периодом (changes), у сегментов нет.
 */
export default {
  name: "RumMetricsTable",
  components: {RumShareBar},
  props: {
    rows: {type: Array, required: true},
    nameTitle: {type: String, default: 'Название'},
    // У разрезов по устройству, сети и стране сайт оценку не ставит вовсе —
    // пустая колонка там читалась бы как «мало данных».
    rated: {type: Boolean, default: true},
  },
  data() {
    return {
      sortKey: 'views',
      sortAsc: false,
      metrics: RUM_METRICS,
      ratingText: RATING_TEXT,
      ratingBadge: RATING_BADGE,
    }
  },
  computed: {
    columns() {
      return [
        {key: 'views', title: 'Просмотры'},
        {key: 'bounceRate', title: 'Отказы', hint: 'Ушли, ничего не сделав на странице'},
        ...RUM_METRICS.map(m => ({key: m, title: METRIC_TEXT[m].name, hint: METRIC_TEXT[m].hint})),
      ]
    },
    sortedRows() {
      const value = (row) => (RUM_METRICS.includes(this.sortKey) ? this.p75(row, this.sortKey) : row[this.sortKey])
      const dir = this.sortAsc ? 1 : -1

      // Пустые значения — всегда в конце, в какую сторону ни сортируй.
      return [...this.rows].sort((a, b) => {
        const x = value(a)
        const y = value(b)
        if (x === null || x === undefined) return 1
        if (y === null || y === undefined) return -1
        return (x - y) * dir
      })
    },
  },
  methods: {
    formatMetric,
    formatPercent,
    formatCount,
    p75(row, metric) {
      return row.metrics?.[metric]?.p75 ?? null
    },
    change(row, metric) {
      return row.changes ? formatChange(row.changes[metric]) : null
    },
    shares(summary) {
      return {good: summary.good || 0, ni: summary.ni || 0, poor: summary.poor || 0}
    },
    sortBy(key) {
      if (this.sortKey === key) {
        this.sortAsc = !this.sortAsc
      } else {
        this.sortKey = key
        this.sortAsc = false
      }
    },
  },
}
</script>
